import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropZone", "fileInput", "preview"]

  connect() {
    this.files = []
    this.maxFileSize = 5 * 1024 * 1024 // 5MB
    this.allowedTypes = ['image/jpeg', 'image/png', 'image/gif']
  }

  preventDefault(event) {
    event.preventDefault()
    event.stopPropagation()
  }

  handleDragEnter(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.add('border-primary', 'bg-light')
  }

  handleDragLeave(event) {
    event.preventDefault()
    if (!this.dropZoneTarget.contains(event.relatedTarget)) {
      this.dropZoneTarget.classList.remove('border-primary', 'bg-light')
    }
  }

  handleDrop(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.remove('border-primary', 'bg-light')

    const files = Array.from(event.dataTransfer.files)
    this.processFiles(files)
  }

  handleFileSelect(event) {
    const files = Array.from(event.target.files)
    this.processFiles(files)
  }

  processFiles(files) {
    const validFiles = files.filter(file => this.validateFile(file))

    if (validFiles.length > 0) {
      this.files = [...this.files, ...validFiles]
      this.updateFileInput()
      this.renderPreviews(validFiles)
    }
  }

  validateFile(file) {
    // ファイルタイプチェック
    if (!this.allowedTypes.includes(file.type)) {
      alert(`${file.name} は許可されていないファイル形式です。JPG, PNG, GIFのみアップロード可能です。`)
      return false
    }

    // ファイルサイズチェック
    if (file.size > this.maxFileSize) {
      alert(`${file.name} はファイルサイズが大きすぎます。5MB以下のファイルを選択してください。`)
      return false
    }

    return true
  }

  updateFileInput() {
    // DataTransferオブジェクトを作成して、ファイル入力を更新
    const dataTransfer = new DataTransfer()
    this.files.forEach(file => dataTransfer.items.add(file))
    this.fileInputTarget.files = dataTransfer.files
  }

  renderPreviews(files) {
    const container = this.previewTarget.querySelector('#preview-container')
    if (!container) return

    files.forEach((file, index) => {
      const reader = new FileReader()

      reader.onload = (e) => {
        const col = document.createElement('div')
        col.className = 'col-6 col-md-3'

        const wrapper = document.createElement('div')
        wrapper.className = 'position-relative'
        wrapper.dataset.fileIndex = this.files.indexOf(file)

        const img = document.createElement('img')
        img.src = e.target.result
        img.className = 'img-fluid rounded shadow-sm'
        img.style.width = '100%'
        img.style.height = '150px'
        img.style.objectFit = 'cover'

        const removeBtn = document.createElement('button')
        removeBtn.type = 'button'
        removeBtn.className = 'btn btn-sm btn-danger position-absolute top-0 end-0 m-1'
        removeBtn.innerHTML = '<i class="bi bi-x"></i>'
        removeBtn.onclick = () => this.removePreview(file, col)

        wrapper.appendChild(img)
        wrapper.appendChild(removeBtn)
        col.appendChild(wrapper)
        container.appendChild(col)
      }

      reader.readAsDataURL(file)
    })
  }

  removePreview(file, element) {
    // ファイル配列から削除
    const index = this.files.indexOf(file)
    if (index > -1) {
      this.files.splice(index, 1)
    }

    // ファイル入力を更新
    this.updateFileInput()

    // プレビューから削除
    element.remove()
  }

  removeExisting(event) {
    const index = event.params.index
    const photoElement = event.target.closest('.col-6')

    // 既存写真を削除するために、削除フラグ用のhidden fieldを追加
    const form = this.element.closest('form')
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = `training_record[remove_photos][]`
    input.value = index
    form.appendChild(input)

    // UIから削除
    photoElement.remove()
  }
}
